/*
 * @Author: edvardchen
 * @Date:   2017-07-04 17:42:26
 * @Last Modified by: edvardchen
 * @Last Modified time: 2018-04-11 21:50:06
 */
// import React from 'react';
// import Image from '../Image';

// @flow
import _ from 'lodash';
import querystring from 'query-string';

const emotionUrl = 'https://res.imtt.qq.com/tagapp/v1/img/qqface'; // png图片地址
const emotions = [
  '微笑',
  '撇嘴',
  '色',
  '发呆',
  '得意',
  '流泪',
  '害羞',
  '闭嘴',
  '睡',
  '大哭',
  '尴尬',
  '发怒',
  '调皮',
  '呲牙',
  '惊讶',
  '难过',
  '酷',
  '冷汗',
  '抓狂',
  '吐',
  '偷笑',
  '可爱',
  '白眼',
  '傲慢',
  '饥饿',
  '困',
  '惊恐',
  '流汗',
  '憨笑',
  '大兵',
  '奋斗',
  '咒骂',
  '疑问',
  '嘘',
  '晕',
  '折磨',
  '衰',
  '骷髅',
  '敲打',
  '再见',
  '擦汗',
  '抠鼻',
  '鼓掌',
  '糗大了',
  '坏笑',
  '左哼哼',
  '右哼哼',
  '哈欠',
  '鄙视',
  '委屈',
  '快哭了',
  '阴险',
  '亲亲',
  '吓',
  '可怜',
  '菜刀',
  '西瓜',
  '啤酒',
  '篮球',
  '乒乓',
  '咖啡',
  '饭',
  '猪头',
  '玫瑰',
  '凋谢',
  '示爱',
  '爱心',
  '心碎',
  '蛋糕',
  '闪电',
  '炸弹',
  '刀',
  '足球',
  '瓢虫',
  '便便',
  '月亮',
  '太阳',
  '礼物',
  '拥抱',
  '强',
  '弱',
  '握手',
  '胜利',
  '抱拳',
  '勾引',
  '拳头',
  '差劲',
  '爱你',
  'NO',
  'OK',
  '爱情',
  '飞吻',
  '跳跳',
  '发抖',
  '怄火',
  '转圈',
  '磕头',
  '回头',
  '跳绳',
  '挥手',
];

const otherEmotions = {
  哈哈: '憨笑',
  喜欢: '色',
  哭: '流泪',
  吃惊: '惊讶',
  汗: '流汗',
  生气: '发怒',
  大笑: '憨笑',
  奸笑: '坏笑',
  亲: '亲亲',
  愤怒: '发怒',
  顶: '强',
  心: '爱心',
  点赞: '强',
};

const emotionReg = /\[\/?([^[]+?)\]/g;
const talkReg = /#([^#]+?)#/g;

const traverse = (str, regexp, handle) => {
  const parts = [];

  let prev = 0;
  str.replace(regexp, (match, capture, offset) => {
    const result = handle(match, capture);
    if (result) {
      parts.push(str.substring(prev, offset), result);
      prev = offset + match.length;
    }
    return match;
  });
  if (prev !== str.length - 1 || !parts.length) {
    parts.push(str.substring(prev));
  }
  return parts;
};

export default (content: string = '') => {
  // extract images
  let parts = traverse(content, emotionReg, (match, capture) => {
    let index = emotions.indexOf(capture);
    if (index < 0) {
      index = emotions.indexOf(otherEmotions[capture]);
    }
    if (index !== -1) {
      const src = `${emotionUrl}/${index + 1}.png`;
      return {
        type: 'emotion',
        src,
      };
    }
    return undefined;
  });

  // extract talks
  parts = parts.map((item) => {
    if (typeof item === 'string') {
      return traverse(item, talkReg, (match, capture) => {
        try {
          const { title, talkid } = querystring.parse(capture);
          if (title && talkid) {
            return {
              type: 'talk',
              title,
              id: talkid,
            };
          }
        } catch (e) {
          /* ignore */
        }
        return undefined;
      });
    }
    return item;
  });
  return _.flatten(parts);
};
